import { render, staticRenderFns } from "./PageStadiumChats.vue?vue&type=template&id=2828536c&"
import script from "./PageStadiumChats.vue?vue&type=script&lang=js&"
export * from "./PageStadiumChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports